var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTotalDriver = function SvgTotalDriver(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EAE9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75C12.31 15.75 11.75 16.31 11.75 17C11.75 17.69 12.31 18.25 13 18.25C13.69 18.25 14.25 17.69 14.25 17C14.25 16.31 13.69 15.75 13 15.75ZM19 15.75C18.31 15.75 17.75 16.31 17.75 17C17.75 17.69 18.31 18.25 19 18.25C19.69 18.25 20.25 17.69 20.25 17C20.25 16.31 19.69 15.75 19 15.75ZM16 6C10.48 6 6 10.48 6 16C6 21.52 10.48 26 16 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 16 6ZM16 24C11.59 24 8 20.41 8 16C8 15.71 8.02 15.42 8.05 15.14C10.41 14.09 12.28 12.16 13.26 9.77C15.07 12.33 18.05 14 21.42 14C22.2 14 22.95 13.91 23.67 13.74C23.88 14.45 24 15.21 24 16C24 20.41 20.41 24 16 24Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTotalDriver);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "totalDriver.05684662cfaa17d6d2c0e3adcee748b8.svg";